const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000/api";
// Same host as API_BASE but without the trailing "/api" — used for /uploads and other non-/api routes
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

export function getAuthToken() {
  return window.localStorage.getItem("circuit_admin_token");
}

export function setAuthToken(token) {
  window.localStorage.setItem("circuit_admin_token", token);
}

export function clearAuthToken() {
  window.localStorage.removeItem("circuit_admin_token");
}

export async function apiRequest(path, options = {}) {
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  const token = getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export default API_BASE;
